<script setup lang="ts">
import type { FooterNavigationApiModel } from '@gro-up/api/corporate'
import { FooterLinkList, FooterSocialList } from '@gro-up/ui/components'
import { Container, Logo, Link, Typography, Grid, HorizontalBulletList } from '@gro-up/ui/primitives'

const { bottomLinks, columns, socialLinks } = defineProps<FooterNavigationApiModel>()

const year = new Date().getFullYear()
</script>

<template>
  <footer class="w-full bg-head-office-40 text-primary-100 relative z-10">
    <Container class="flex justify-center items-center">
      <div class="relative w-full h-full pt-[30px] md:pt-[60px] pb-[15px] md:pb-[30px] flex flex-col gap-[30px] md:gap-[40px]">
        <div class="absolute left-0 -top-[25px] md:-top-[35px]">
          <Link to="/" aria-label="Home">
            <Logo aria-hidden="true" variant="footer-dark" />
          </Link>
        </div>
        <Grid class="gap-y-10">
          <nav
            v-for="(nav, index) in columns"
            :key="`nav-${index}`"
            class="col-span-6 lg:col-span-3"
            aria-label="Footer navigatie">
            <FooterLinkList :title="nav.title ?? ''" :links="nav.links" />
          </nav>
        </Grid>
        <div
          class="flex flex-col items-center gap-[30px] md:gap-[40px] py-[3px] flex-col-reverse md:flex-row md:justify-between order-3 md:order-2">
          <FooterSocialList class="text-primary-100 mx-auto md:mx-0 order-2 md:order-3" variant="dark" :socials="socialLinks" />
          <HorizontalBulletList>
            <Typography as="span" variant="footer-bulletlist" class="inline"> © {{ year }} gro-up </Typography>
            <Link
              v-for="(link, index) in bottomLinks"
              :key="link.title ?? `bottomlink-${index}`"
              :to="link.url ?? ''"
              variant="footer-bulletlist"
              class="inline-flex min-h-6 items-center">
              {{ link.title }}
            </Link>
          </HorizontalBulletList>
        </div>
      </div>
    </Container>
  </footer>
</template>

